module.exports = __webpack_public_path__ + "img/FastMetabolism.e6c98813.png";